require('share/share_context')
require('share/actions/share_actions')
require('share/components/link_share_modal')

Share = LP.module 'Share'

Share.init = ->
  @context = new @ShareContext LP.config

Share.initShareActionButtons = (domEL) ->
  that = @
  domEL.each (i, button) ->
    root = ReactDOM.createRoot(button);
    root.render(
      React.createElement(Share.ShareButton,
        parentElement: $(button).closest('tr'),
        context:       that.context,
        data:          $(button).data()
      )
    );

Share.triggerShareByLinkModal = (data) ->
  container = $('#js-share-by-link-modal')
  if container.length > 0
    container.empty()
  else
    container = $('<div id="js-share-by-link-modal" />').appendTo('body')

  root = ReactDOM.createRoot(container[0])
  root.render(
    React.createElement(
      LP.module('Share').LinkShareModal, {
        data: data,
        closePopover: ->
          root.unmount()
          return false;
      }
    )
  );

Share.bindRRPShareButtons = ->
  $(document).off('click', '#share_by_link')
  $(document).on('click', '#share_by_link', (event) ->
    event.preventDefault();
    Share.triggerShareByLinkModal($($(event.target).closest('a')).data());
    return
  )
  return
